export default __webpack_public_path__ + "static/media/roma-logo.a5e05284.png";